import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'
import { generateEntityId } from '../generateEntityId'
import { SecretKindEnum } from './SecretKindEnum'

/** One AES-256-GCM sealed value, all three parts base64. */
export type SealedValue = { iv: string; tag: string; ciphertext: string }

/** A data key wrapped by a `DataKeyWrapper`, stored on the secret row. */
export type WrappedKey = SealedValue

/**
 * One tenant's encrypted secrets of one kind. Each field of `secrets` is sealed with the row's data key; the data
 * key is stored wrapped by the master key (`wrappedKey`). `tail` is the last four characters of a value of eight or
 * more, the only plaintext kept. Neither `wrappedKey` nor `secrets` is exposed to GraphQL.
 */
@ObjectType()
@InputType('SecretInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class Secret extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('sec') })
  declare _id: string

  @Field(() => SecretKindEnum)
  @Prop({ type: String, required: true, enum: SecretKindEnum })
  kind: SecretKindEnum

  @Prop({ type: Object, required: true })
  wrappedKey: WrappedKey

  @Prop({ type: String })
  keyProvider: string

  @Prop({ type: Number })
  version: number

  @Prop({ type: Object, default: {} })
  secrets: Record<string, SealedValue & { tail?: string }>
}
